import { WSCard } from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { queriesInternalAccounts } from "@query";
import { useQueryOwnPayoutSettings } from "@hooks/useQueryOwnPayoutSettings";
import { selectorAccountBalance } from "../../../shared/selectors/selectorAccountBalance";
import { PATH_PLATFORM_BALANCE } from "../paths";
import { selectorIsPlatformBalanceAccount } from "../selectors/selectorIsPlatformBalanceAccount";

export const WidgetPlatformBalance: React.FC = () => {
  const history = useHistory();
  const queryInternalAccounts =
    queriesInternalAccounts.listInternalAccounts.useQuery();
  const queryPayoutSettings = useQueryOwnPayoutSettings();

  const apPayoutAccount = useMemo(() => {
    if (!queryInternalAccounts.data || !queryPayoutSettings.data) {
      return;
    }

    return queryInternalAccounts.data.data?.find(internalAccount =>
      selectorIsPlatformBalanceAccount(
        internalAccount,
        queryPayoutSettings.data
      )
    );
  }, [queryInternalAccounts.data, queryPayoutSettings.data]);

  const queryInternalAccountBalance =
    queriesInternalAccounts.getInternalAccountBalance.useQuery(
      { internalAccountId: apPayoutAccount?.id! },
      {
        enabled: !!apPayoutAccount
      }
    );

  if (!apPayoutAccount || !queryInternalAccountBalance.data) {
    return null;
  }

  return (
    <WSCard
      divider
      header={{
        label: "Platform balance",
        value: {
          value: formatMoney(
            selectorAccountBalance(queryInternalAccountBalance.data).balance,
            selectorAccountBalance(queryInternalAccountBalance.data).currency
          )
        }
      }}
      actions={{
        alignment: "left",
        buttons: [
          {
            kind: "Link",
            label: "View details",
            onClick: () => {
              history.push(PATH_PLATFORM_BALANCE);
            }
          }
        ]
      }}
    />
  );
};
